import React from "react";
import styled from "styled-components";
import { Box } from "@thenounproject/lingo-core";
import { getColor } from "../../../../../core/src/components/utils";

type SelectionWrapperProps = {
  selected?: boolean;
  children: React.ReactNode;
};

const Wrapper = styled(Box).attrs<{ selected?: boolean; canEdit?: boolean }>(props => ({
  position: "relative",
  m: "-4px",
  p: "4px",
  borderRadius: "6px",
  border: `2px solid ${
    props.selected ? getColor(props.theme.primaryColor, "primary") : "transparent"
  }`,
}))<{ selected?: boolean; canEdit?: boolean }>``;

export const SelectionWrapper: React.FC<SelectionWrapperProps> = ({ selected, children }) => (
  <Wrapper selected={selected}>{children}</Wrapper>
);
